import api from "../api";

export const authService = {

  requestOTP: async (phoneNumber, purpose) => {
    const response = await api.post("/accounts/auth/otp/", {
      phone_number: phoneNumber,
      purpose: purpose,
    });
    return response.data;
  },

  registerCustomer: async ({ phoneNumber, fullName, password, passwordConfirm, otp }) => {
    const response = await api.post("/accounts/auth/customer-register/", {
      phone_number: phoneNumber,
      full_name: fullName,
      password: password,
      password_confirm: passwordConfirm,
      otp: otp,
    });
    return response.data;
  },

  adminCreateUser: async ({ phoneNumber, fullName, role }) => {
    const response = await api.post("/accounts/auth/admin-register/", {
      phone_number: phoneNumber,
      full_name: fullName,
      role_id: role,
    });
    return response.data;
  },

  loginWithPassword: async (phoneNumber, password) => {
    const response = await api.post("/accounts/auth/login/password/", {
      phone_number: phoneNumber,
      password: password,
    });
    return response.data;
  },

  loginWithOTP: async (phoneNumber, otp) => {
    const response = await api.post("/accounts/auth/login/otp/", {
      phone_number: phoneNumber,
      otp: otp,
    });
    return response.data;
  },

  setInitialPassword: async (newPassword, newPasswordConfirm) => {
    const response = await api.post("/accounts/auth/password/set-initial/", {
      new_password: newPassword,
      new_password_confirm: newPasswordConfirm,
    });
    return response.data;
  },

  changePasswordWithOld: async (oldPassword, newPassword, newPasswordConfirm) => {
    const response = await api.post("/accounts/auth/password/change/old-password/", {
      old_password: oldPassword,
      new_password: newPassword,
      new_password_confirm: newPasswordConfirm,
    });
    return response.data;
  },


  changePasswordWithOTP: async ({ phoneNumber, otp, newPassword, newPasswordConfirm }) => {
    const response = await api.post("/accounts/auth/password/change/otp/", {
      phone_number: phoneNumber,
      otp: otp,
      new_password: newPassword,
      new_password_confirm: newPasswordConfirm,
    });
    return response.data;
  },

  forgotPassword: async ({ phoneNumber, otp, newPassword, newPasswordConfirm }) => {
    const response = await api.post("/accounts/auth/password/forgot-reset/", {
      phone_number: phoneNumber,
      otp: otp,
      new_password: newPassword,
      new_password_confirm: newPasswordConfirm,
    });
    return response.data;
  },

  refreshToken: async (refreshToken) => {
    const response = await api.post("/accounts/token/", {
      refresh: refreshToken,
    });
    return response.data;
  },
};
